import React, { useReducer } from 'react';

import { ApplicationsContext } from './ApplicationsContext';
import { ApplicationsContextProviderProps } from './ApplicationsContext.types';
import {
  ADD_APPLICATION,
  applicationsReducer,
  REMOVE_APPLICATION,
  SET_ACTIVE_APPLICATION,
  UPDATE_APPLICATION,
} from './reducer/applicationsReducer';

export const ApplicationsContextProvider = ({
  applications: applicationsInit,
  children,
}: ApplicationsContextProviderProps) => {
  const [state, dispatch] = useReducer(applicationsReducer, { applications: applicationsInit });

  return (
    <ApplicationsContext.Provider
      value={{
        activeApplication: state.activeApplication,
        addApplication: application => dispatch({ type: ADD_APPLICATION, application }),
        applications: state.applications,
        removeApplication: uuid => dispatch({ type: REMOVE_APPLICATION, uuid }),
        setActiveApplication: uuid => dispatch({ type: SET_ACTIVE_APPLICATION, uuid }),
        updateApplication: application => dispatch({ type: UPDATE_APPLICATION, application }),
      }}
    >
      {children}
    </ApplicationsContext.Provider>
  );
};
